import { useQuery } from '@tanstack/react-query';
import * as api from 'util/api';

export default (runId, { refetchInterval, enabled } = {}) => useQuery({
  queryKey: ['segmentation', 'run', runId],
  queryFn: () => api.getSegmentationRun(runId),
  enabled: enabled ?? runId != null,
  refetchInterval,
});
